const HardErrors = {
  401: {
    msg: "Contraseña o Usuario Incorrecto",
    verifications: (logout) => (logout && logout()) || true,
  },
  451: {
    msg: "Contraseña expirada. Cambie su contraseña",
    verifications: (logout) => (logout && logout()) || true,
  },
  403: {
    msg: "No esta autorizado a acceder al recurso",
    verifications: (refreshToken) => !refreshToken || !refreshToken(),
  },
  419: {
    msg: "Ha finalizado la session",
    verifications: (logout) => (logout && logout()) || true,
  },
  423: {
    msg: 'Cuenta bloqueada, recuperar con "Olvidé mi contraseña"',
    verifications: (logout) => (logout && logout()) || true,
  },
  429: {
    msg: "Demasiadas solicitudes, Renitente mas tarde",
    verifications: () => true,
  },
  504: {
    msg: "",
    verifications: () => true,
  },
  502: {
    msg: "",
    verifications: () => true,
  },
  500: {
    msg: "",
    verifications: () => true,
  },
};
const ERROR_SYMBOL = Symbol("errorTracking");
const globalState = {
  [ERROR_SYMBOL]: new Set(),
};
const displayedErrors = globalState[ERROR_SYMBOL];

const msgCallback = (msg, _msgCallback) => {
  if (!displayedErrors.has(msg)) {
    displayedErrors.add(msg);
    _msgCallback(msg);
    setTimeout(() => {
      displayedErrors.delete(msg);
    }, 5000); // 5000ms = 5s, tiempo de duración de la Toast
  }
};
const handleErrors = (error, _msgCallback, _refreshToken, formik = null) => {
  if (error.isSoftError) {
    // is JSON service error
    msgCallback(error.message, _msgCallback);

    if (error.fields && formik) {
      error.fields.forEach((field) => {
        formik.setFieldError(field.param, field.msg);
      });
    }
  } else {
    // Comunication or local javascript error
    const { msg, verifications } = HardErrors[error.httpCode];
    // eslint-disable-next-line no-console
    console.log(error, msg);
    if (verifications(_refreshToken)) return msg && msgCallback(msg, _msgCallback);
    msgCallback("Error desconocido, intente nuevamente", _msgCallback);
  }
  return null;
};

export default handleErrors;
export { handleErrors };
